import { Dictionary } from "@insite/client-framework/Common/Types";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SetFilterQuery,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { isLoadMore } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import cloneDeep from "lodash/cloneDeep";
import qs from "qs";

// Include Dillon custom multi-category and wishlist facet keys so they are driven by
// productFilters state (not re-applied from the current URL as "third-party" params).
// Without this, remove/clear cannot drop these facets after the 5.2.2605.600 SetFilterQuery change.
const knownFilterKeys = new Set([
    "criteria",
    // HasPagingParameters
    "page",
    "pageSize",
    "defaultPageSize",
    "sort",
    // ProductFilters
    "pageCategoryId",
    "pageBrandId",
    "pageProductLineId",
    "query",
    "includeSuggestions",
    "stockedItemsOnly",
    "previouslyPurchasedProducts",
    "searchWithinQueries",
    "brandIds",
    "productLineIds",
    "priceFilters",
    "attributeValueIds",
    "categoryId",
    "expand",
    "additionalExpands",
    // Verndale Customization
    "categoryIds",
    "wishlistIds",
]);

replaceInChain(chain, SetFilterQuery, props => {
    const queryObject = cloneDeep(props.getState().pages.productList.productFilters);
    delete queryObject.expand;
    delete queryObject.pageCategoryId;
    delete queryObject.pageProductLineId;
    delete queryObject.pageBrandId;

    if (isLoadMore(props.getState())) {
        delete queryObject.pageSize;
    }

    if (queryObject.searchWithinQueries && queryObject.searchWithinQueries.length > 1) {
        // Search within Queries need to split by space, to use for ElasticSearch
        queryObject.searchWithinQueries = [queryObject.searchWithinQueries.join(" ")];
    }

    const currentSearch = typeof window !== "undefined" ? window.location.search : "";
    const currentParams = qs.parse(currentSearch, { ignoreQueryPrefix: true });
    const thirdPartyParams: Dictionary<unknown> = {};
    for (const key of Object.keys(currentParams)) {
        if (!knownFilterKeys.has(key)) {
            thirdPartyParams[key] = currentParams[key];
        }
    }

    const mergedQuery = { ...queryObject, ...thirdPartyParams };
    props.result = qs.stringify(mergedQuery, { arrayFormat: "comma", skipNulls: true });
});
